import Table from 'components/Display/Table/Table'
import Page from 'components/Page/Page'
import useFormMeterLogic from 'logic/Meters/useFormMeterLogic'
import useMeters from 'logic/Meters/useMeters'
import React from 'react'
import tableActions from 'constants/tableActions'
import {
    useCreateMeterMutation,
    useDeleteMeterMutation,
    useGetMetersQuery,
    useEditMeterMutation,
    useGetMeterQuery,
} from 'store/Store'

const Meters = () => {
    return (
        <Page>
            <Table
                itemName="meter"
                paginationType="external"
                allowDelete
                allowEdit
                allowCreate
                allowExpanded
                useEditMutation={useEditMeterMutation}
                useGetQuery={useGetMetersQuery}
                useGetByIdQuery={useGetMeterQuery}
                useCreateMutation={useCreateMeterMutation}
                useDeleteMutation={useDeleteMeterMutation}
                useModal={useMeters}
                useFormLogic={useFormMeterLogic}
                tableActions={tableActions.meterTableActions}
            />
        </Page>
    )
}

export default Meters
